// extracted by mini-css-extract-plugin
export default {"box":"TypeSelector_box__6r-x3","item":"TypeSelector_item__QFGnL","select":"TypeSelector_select__vDu5j"};